import { Icon } from '@thro-types/users';

import { Gateway } from 'index';

interface S3UploadProps {
  file: Blob;
  icon: Icon;
  type: 'default' | 'category';
}

export const uploadIconToS3 = async ({ file, icon }: S3UploadProps) => {
  const formData = new FormData();
  if (file instanceof Blob) {
    formData.append('file', file);
    if (icon.isDefault) {
      formData.append('isRounded', String(icon.isRounded));
      formData.append('isDefault', String(true));
    }
  }

  const { data }: { data: Icon } = await Gateway.putForm(`/users/v1/icons`, formData);

  return data;
};
